import React from 'react';
import { getPlaybookById } from '../../../data/playbookTaxonomy';
import PlaybookSection from '../../../components/playbooks/PlaybookSection';
import StageCards from '../../../components/playbooks/StageCards';
import ToolCallout from '../../../components/playbooks/ToolCallout';
import { 
  RocketLaunchIcon,
  ChartBarIcon,
  PresentationChartLineIcon,
  DocumentTextIcon,
  BookOpenIcon,
  ChatBubbleLeftRightIcon
} from '@heroicons/react/24/outline';

const StorytellingWithDataHowToExecute = () => {
  const playbook = getPlaybookById('storytelling-with-data');
  
  const stageIcons = {
    'stage-1': <ChartBarIcon className="h-6 w-6 text-primary-light" />,
    'stage-2': <PresentationChartLineIcon className="h-6 w-6 text-primary-light" />,
  };

  const introText = `
    This playbook will guide you through the process of using data and storytelling to get heard and influence effectively. 
    Each stage builds upon the previous one, helping you create a compelling narrative backed by solid data.
  `;

  return (
    <div className="space-y-8">
      <PlaybookSection
        title="How To Execute"
        icon={<RocketLaunchIcon className="h-7 w-7 text-primary-light" />}
        heading="Implementation Guide"
      >
        <div className="prose prose-invert max-w-none mb-8">
          <p className="text-gray-300">
            {introText}
          </p>
        </div>

        <StageCards
          stages={playbook.sections.filter(section => section.id.startsWith('stage-'))}
          icons={stageIcons}
          playbookId={playbook.id}
          introText={introText}
        />

        
      </PlaybookSection>
    </div>
  );
};

export default StorytellingWithDataHowToExecute; 